"use strict";

const FORCE_OFFLINE_MODE_KEY = "krk_force_offline_sandbox";

export function shouldLoadForceOffline(pathname = location.pathname): boolean {
  return pathname.endsWith("/") || pathname.endsWith("/index.html");
}

export function readStoredForceOfflineMode(): boolean {
  try {
    const value = localStorage.getItem(FORCE_OFFLINE_MODE_KEY);
    return value == null ? true : value === "true" || value === "1";
  } catch {
    return true;
  }
}

export function writeStoredForceOfflineMode(value: boolean): void {
  try {
    localStorage.setItem(FORCE_OFFLINE_MODE_KEY, String(value));
  } catch {}
}

function applyV3OfflineUrl(): void {
  const params = new URLSearchParams(location.search);
  params.set("test", "");
  params.delete("sandbox");
  const query = params.toString();
  history.replaceState(
    history.state,
    document.title,
    location.pathname + (query ? "?" + query : "") + location.hash,
  );
}

export function clearV3OfflineUrl(): void {
  const params = new URLSearchParams(location.search);
  params.delete("test");
  params.delete("sandbox");
  const query = params.toString();
  history.replaceState(
    history.state,
    document.title,
    location.pathname + (query ? "?" + query : "") + location.hash,
  );
}

export function normalizeSandboxUrl(): void {
  if (!location.search.includes("sandbox")) return;
  applyV3OfflineUrl();
}

export function forceOfflineUrlIfEnabled(): void {
  window.forceOfflineMode = readStoredForceOfflineMode();
  if (!window.forceOfflineMode || !shouldLoadForceOffline()) return;
  if (new URLSearchParams(location.search).has("test")) return;
  applyV3OfflineUrl();
}
